export const sortOption = {
  relevance: { VAL: 'relevance', TXT: '관련성' },
  date: { VAL: 'date', TXT: '업로드 날짜' },
  viewCount: { VAL: 'viewCount', TXT: '조회수' },
  rating: { VAL: 'rating', TXT: '평점' },
};
